<!-- <div class="isRequiredStyle">
</div> -->
<mat-form-field [appearance]="appearance" [ngClass]="readOnly ? 'disabled' : ''">
	<mat-label>{{ placeholder }}</mat-label>
	<input
		[required]="control.isRequired"
		[readonly]="readOnly"
		[type]="ctype"
		matInput
		[formControl]="control"
		[name]="control.name"
		[max]="max"
		[min]="min"
		[errorStateMatcher]="matcher"
		[maxlength]="control.maxLengthValue"
	/>

	<mat-icon matSuffix class="selectColor" (click)="openColorPicker()" [style.color]="color">invert_colors</mat-icon>

	<mat-hint *ngIf="displayHint" align="end"
		><span *ngIf="control.value">{{ control.value.length }}</span
		><span *ngIf="!control.value">0</span> / {{ control.maxLengthValue }}</mat-hint
	>

	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-form-field>

<wncm-form-control-color-picker #colorPicker (event)="setColor($event)"></wncm-form-control-color-picker>
